<template lang="pug">
d-drag-and-drop-base.rounded-xl.relative(
  v-bind="$attrs"
  v-on="$listeners"
  :class="{ 'pointer-events-none': loading }"
  v-slot="{ dragging }"
)
  .d-drag-and-drop(
    :class="[fieldClasses, { 'd-drag-and-drop--active': dragging }]"
  )
    v-progress-circular(
      v-if="loading"
      :size="64"
      indeterminate
      color="ui-primary"
    )
    v-icon(
      v-else
      :size="64"
      :color="dragging ? 'ui-success' : 'ui-primary'"
    ) $ui-cloud
    p Перенесите файл в поле или загрузите с устройства
</template>

<script>
import DDragAndDropBase from './DDragAndDropBase.vue';

export default {
  components:  { DDragAndDropBase },
  props: {
    loading: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      fieldClasses: [
        'pa-6',
        'd-flex',
        'flex-column',
        'gap-10 ga-2',
        'align-center',
        'text-center',
        'ui-body-1',
      ],
    };
  },
};
</script>

<style lang="scss" scoped>
.d-drag-and-drop {
  border-radius: inherit;
  border-width: 2px;
  border-style: dashed;
  transition: all 0.3s ease;
  background-color: transparent;
  &:not(.d-drag-and-drop--active) {
    border-color: #{$ui-primary};
  }
  &--active {
    border-color: #{$ui-success};
    background-color: #{$ui-success-lighten4};
  }
}
</style>
